module.exports = __webpack_public_path__ + "static/media/meditation5_1.5fa6795a.mp3";